import React from "react";

export const TimeInput = ({ input, label, disabled, min, max, meta: { touched, error, warning } }) => (
    <div>
        {label && <label className="control-label">{label}</label>}
        <input
            {...input}
            type='time'
            disabled={disabled}
            min={min}
            max={max}
            className="form-control" />
        {touched && ((error && <span style={{ color: "red", marginLeft: "5px" }}>{error}</span>) || (warning &&
            <span>{warning}</span>))}
    </div>
);

TimeInput.defaultProps = {
    disabled: false
};


// WEBPACK FOOTER //
// ./src/components/common/TimeInput.jsx